import { Component, OnInit } from '@angular/core';
import { Distributor, Dealer, Course, Employee } from '../../model/distributor.model';
import { DistributorService } from '../../services/distributor.service';
import { forkJoin } from 'rxjs/observable/forkJoin';

@Component({
  selector: 'app-dealer-profile',
  templateUrl: './dealer-profile.component.html',
  styleUrls: ['./dealer-profile.component.scss']
})
export class DealerProfileComponent implements OnInit {

  dealer: Dealer = new Dealer({});
  distributor: Distributor = new Distributor({});
  employees: Array<Employee> = [];
  training: Array<Course> = [];
  isLoading = true;
  activityText = 'Loading...';
  completionPopupData = {
    title: '',
    visible: false,
    message: ''
  };

  constructor(private distributorSvc: DistributorService) { }

  ngOnInit() {
    this.isLoading = true;
    this.loadData(() => {
      this.isLoading = false;
    });
  }

  loadData(cb) {
    forkJoin(
      this.distributorSvc.fetchDealer(),
      this.distributorSvc.fetchTrainingByDealer()
    ).subscribe(results => {
      this.dealer = results[0];
      this.distributor = results[0].distributor;
      this.employees = results[0].employees;
      this.training = results[1];
      if (cb) {
        cb();
      }
    });
  }

  presentCompletionModal(title, message) {
    this.completionPopupData.title = title;
    this.completionPopupData.message = message;
    this.completionPopupData.visible = true;
  }

  whenUpdateRequest(text: string) {
    this.activityText = 'Updating...';
    this.isLoading = true;
    this.distributorSvc.updateDistributorRequest(text).subscribe(data => {
      this.isLoading = false;
      this.presentCompletionModal('Update Request Sent', 'Your Update Request has been sent.');
    }, err => {
      this.isLoading = false;
      this.presentCompletionModal('Update Request Error', err.error.message);
    });
  }

  whenAddEmployee(employee: Employee) {
      this.activityText = 'Adding...';
      this.isLoading = true;
    this.distributorSvc.addEmployee(employee).subscribe(data => {
      this.loadData(() => {
        this.isLoading = false;
        this.presentCompletionModal('New Employee Added', `You have successfully added <strong>${employee.firstName}</strong>.`);
      });
    }, err => {
      this.isLoading = false;
      this.presentCompletionModal('Add Employee Error', err.error.message);
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/distributor/containers/dealer-profile/dealer-profile.component.ts